
import { memo } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Email } from "@/types/email";

interface EmailListItemProps {
  email: Email;
  isSelected: boolean;
  onSelect: (email: Email, checked: boolean) => void;
}

const EmailListItem = memo(
  ({ email, isSelected, onSelect }: EmailListItemProps) => {
    const handleClick = () => {
      onSelect(email, !isSelected);
    };

    // Handle checkbox change without triggering parent click
    const handleCheckboxChange = (checked: boolean) => {
      onSelect(email, checked);
    };

    // Handle checkbox click to prevent event bubbling
    const handleCheckboxClick = (e: React.MouseEvent) => {
      e.stopPropagation();
    };

    return (
      <div
        className="flex items-start gap-2 p-4 hover:bg-secondary/10 transition-colors cursor-pointer border-b mb-2"
        onClick={handleClick}
      >
        <Checkbox
          checked={isSelected}
          onCheckedChange={(checked) => {
            if (typeof checked === 'boolean') {
              handleCheckboxChange(checked);
            }
          }}
          className="mt-1 flex-shrink-0"
          onClick={handleCheckboxClick}
        />
        <div className="min-w-0 flex-1 text-left">
          <h3 className="font-semibold text-sm leading-tight mb-1 break-words line-clamp-1">
            {email.subject}
          </h3>
          <p className="text-sm text-muted-foreground leading-tight mb-1 break-words line-clamp-1">
            {email.sender}
          </p>
          <p className="text-sm text-muted-foreground/80 leading-snug break-words line-clamp-2">
            {email.preview}
          </p>
        </div>
      </div>
    );
  },
  // Add a custom equality function to prevent unnecessary re-renders
  (prevProps, nextProps) => {
    return (
      prevProps.email.id === nextProps.email.id &&
      prevProps.isSelected === nextProps.isSelected
    );
  }
);

EmailListItem.displayName = "EmailListItem";

export default EmailListItem;
